import { useEffect, useState } from 'react';
import { identityApiRef, useApi } from '@backstage/core-plugin-api';
import { useIsAdmin } from './useIsAdmin';

const PS_AGENT_GROUPS = new Set(['professional-services']);

function isPsMember(ownershipEntityRefs: string[]): boolean {
  return ownershipEntityRefs
    .filter(ref => ref.startsWith('group:'))
    .map(ref => ref.split('/').pop() ?? '')
    .some(name => PS_AGENT_GROUPS.has(name));
}

/**
 * PS Agent UI access: any Professional Services member, or a configured admin.
 * undefined while identity / admin status is still loading.
 */
export function useCanAccessPsAgent(): boolean | undefined {
  const identityApi = useApi(identityApiRef);
  const isAdmin = useIsAdmin();
  const [isPs, setIsPs] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const identity = await identityApi.getBackstageIdentity();
        if (!cancelled) {
          setIsPs(isPsMember(identity.ownershipEntityRefs ?? []));
        }
      } catch {
        if (!cancelled) {
          setIsPs(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [identityApi]);

  if (isAdmin === true || isPs === true) {
    return true;
  }
  if (isAdmin === undefined || isPs === undefined) {
    return undefined;
  }
  return false;
}
